import React, { Component } from "react";
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://biodit.com">
                BIODIT
        </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
            {' '}All Rights Reserved!
        </Typography>
    );
}